import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ApplyForm from "./ApplyForm";

const GraphicsDesigner: React.FC = () => {
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="Career details" pagesub=" Graphics Designer" />
                        <section className="career-details">
                            <div className="container">
                                <div className="cp-details-wrap">

                                    {/* Manager Info */}
                                    <div className="cp-manager_info">
                                        <h2 className="details-content-title mb-30">
                                            Graphics Designer – (Full-time)
                                        </h2>

                                        <ul className="xb-details-content list-unstyled mb-35">
                                            <li><span>Department :</span> Creative & Branding</li>
                                            <li><span>No. of Openings :</span> (3)</li>
                                            <li><span>Job Type :</span> Full-Time</li>
                                            <li><span>Location :</span> Software Technology Park Chattogram, Level 6, Agrabad Circle, Chittagong, Bangladesh</li>
                                            <li><span>Working days : </span>6 days.</li>
                                            <li><span>Salary Range : </span>Negotiable.</li>
                                            <li><span>Experience Required :</span> 0–4 Year (Fresh Graduates Encouraged)</li>
                                        </ul>

                                        <p className="mb-30">
                                         We’re looking for a creative and detail-oriented Graphics Designer to join our creative team. You will be responsible for designing visually appealing graphics across various digital and print platforms. You should have strong aesthetic sense, excellent attention to detail, and the ability to translate ideas into compelling visual content.
                                        </p>

                                        <p>
                                          You will collaborate closely with marketing, product, and content teams to produce designs that strengthen brand identity and support business objectives.
                                        </p>
                                    </div>

                                    {/* What you'll do */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">What you'll get to do...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Design marketing assets including banners, posters, flyers, and promotional materials.</li>
                                            <li>Create social media creatives, cover images, and ad graphics.</li>
                                            <li>Develop brand materials such as logos, icons, and visual identity elements.</li>
                                            <li>Work with content and digital marketing teams to create campaign visuals.</li>
                                            <li>Prepare print-ready files for production adhering to size, format, and bleed requirements.</li>
                                            <li>Contribute to UI/UX concepts, web page layouts, and wireframes (if required).</li>
                                            <li>Maintain brand consistency across all visual content.</li>
                                            <li>Revise and update existing designs based on feedback.</li>
                                            <li>Participate in creative brainstorming sessions and propose new ideas.</li>
                                        </ul>
                                    </div>

                                    {/* Experience section */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Your experience should include...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Strong proficiency in Adobe Photoshop, Illustrator, and InDesign.</li>
                                            <li>Good understanding of composition, typography, color theory, and layout principles.</li>
                                            <li>Experience designing for both digital and print platforms.</li>
                                            <li>Ability to work under deadlines and manage multiple projects.</li>
                                            <li>Strong communication skills and ability to understand design requirements.</li>
                                            <li>A creative mindset with attention to detail and brand consistency.</li>
                                            <li>A solid design portfolio showcasing previous work.</li>
                                        </ul>
                                    </div>

                                    {/* You might have */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">You might also have...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Experience with Canva, Adobe Photoshop, or Illustrator.</li>
                                            <li>Knowledge of motion graphics or video editing (After Effects, Premiere Pro).</li>
                                            <li>Experience designing website/UI layouts.</li>
                                            <li>Understanding of social media trends and design best practices.</li>
                                            <li>Ability to illustrate custom vectors or character design.</li>
                                            <li>Experience working in fast-paced marketing or agency environments.</li>
                                            <li>Interest in branding, creative direction, and continuous improvement.</li>
                                        </ul>
                                    </div>

                                    {/* Benefits */}
                                    <div className="xb-details-item">
                                        <h3 className="details-title mt-70">Great benefits...</h3>
                                        <ul className="content-list mt-25">
                                            <li>Competitive monthly salary with performance reviews.</li>
                                            <li>Opportunity to work on high-scale, real-world applications.</li>
                                            <li>Friendly and collaborative work environment.</li>
                                            <li>Access to learning materials and training sessions.</li>
                                            <li>Flexible working hours.</li>
                                        </ul>
                                    </div>
                                    
                                    {/* ApplyForm */}
                                    <ApplyForm />

                                </div>
                            </div>
                        </section>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default GraphicsDesigner;
